import { Icon, IconProps } from ".";

export const Siren = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 21 20" {...props}>
      <>
        <path d="M14.2069 4.8125H12.7123V6.30666H14.2069V4.8125Z" />
        <path d="M17.1666 6.29187H15.6719V7.78603H17.1666V6.29187Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2069 7.77124V13.6887H15.6867V15.1829H5.31309V13.6887H6.79293V7.77124H14.2069ZM8.28756 9.2654H9.7526V13.6887H8.28756V9.2654Z"
        />
        <path d="M15.6719 9.2506H17.1666V10.7448H15.6719V9.2506Z" />
        <path d="M6.79293 4.8125H8.28756V6.30666H6.79293V4.8125Z" />
        <path d="M5.32789 6.29187H3.83325V7.78603H5.32789V6.29187Z" />
        <path d="M3.83325 9.2506H5.32789V10.7448H3.83325V9.2506Z" />
      </>
    </Icon>
  );
};
